@let _loading = loading();
@let _noHandshakeCode = noHandshakeCode();
@let _errorAuth = errorAuth();
@let _contractError = contractError();

<div id="sso-callback" class="inner-scroll flex flex-row">
  <div id="sso-callback-form-wrapper" class="flex flex-col flex-1">
    <div class="logo mb-24">
      <img src="assets/images/logos/fluid-logo-alt.png" alt="Fluid Logo" />
    </div>

    @if (_loading) {
      <div class="title h1 mb-24 flex flex-row items-center gap-16">
        <mat-spinner diameter="32"></mat-spinner>
        <span>{{ 'Accesso in corso…' | translate }}</span>
      </div>
    }

    @if (_contractError && !_loading) {
      <div class="title h1 mb-16">{{ 'Accesso SSO' | translate }}</div>
      <p class="mb-16">{{ ssoMessageKey(_contractError.code) | translate }}</p>
      @if (_contractError.ref) {
        <p class="mb-8 text-secondary">
          <strong>{{ 'sso.ref.label' | translate }}</strong>
        </p>
        <p class="mb-16 mono-ref">{{ _contractError.ref }}</p>
        <button type="button" mat-stroked-button color="secondary" class="mb-24" (click)="copySsoRef()">
          {{ 'sso.ref.copy' | translate }}
        </button>
      }
      <a mat-raised-button color="primary" [routerLink]="['/auth/login']">{{ 'Vai al login' | translate }}</a>
    }

    @if (_noHandshakeCode && !_loading && !_contractError) {
      <div class="title h1 mb-16">{{ 'Accesso SSO' | translate }}</div>
      <p class="mb-24">
        {{ 'Nessun codice di accesso nell’URL. Torna al login o completa il login dal portale SSO.' | translate }}
      </p>
      <a mat-raised-button color="primary" [routerLink]="['/auth/login']">{{ 'Vai al login' | translate }}</a>
    }

    @if (_errorAuth && !_loading && !_contractError) {
      <div class="title h1 mb-16">{{ 'Accesso SSO' | translate }}</div>
      <mat-error class="mb-24">
        @switch (_errorAuth) {
          @case (LoginErrorsEnum.required2FA) {
            {{ 'Richiesta autenticazione a due fattori' | translate }}
          }
          @case (LoginErrorsEnum.userDisabled) {
            {{ 'Utente non abilitato' | translate }}
          }
          @case (LoginErrorsEnum.serverError) {
            {{ 'Si è verificato un errore. Riprovare più tardi.' | translate }}
          }
        }
      </mat-error>
      <a mat-raised-button color="primary" [routerLink]="['/auth/login']">{{ 'Vai al login' | translate }}</a>
    }
  </div>
</div>
